export const APPEAL_NEW = 1;
export const APPEAL_REGISTERED = 2;
export const APPEAL_ADDITIONAL = 3;
export const APPEAL_COMPETENCE = 4;
export const APPEAL_RESOLVED = 5;
